'use client';

import { httpMethods } from '@/constants/http-methods';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';
import { ChangeEmailRequest, ExistingPasswordValidatedCredential } from '@cinemark/identity-api-client';
import { Profile, ProfileData } from '@cinemark/profile-api-client';

class ProfileApiService {
  private readonly profileUrl = '/papi/profiles/me';

  async getMyProfile(signal?: AbortSignal): Promise<CommonFetchResponse<Profile | null>> {
    const response = await commonFetch<Profile>(this.profileUrl, { signal });
    return response;
  }

  async updateMyProfile(updateProfile: ProfileData): Promise<Profile> {
    const response = await commonFetch<Profile>(this.profileUrl, {
      body: JSON.stringify(updateProfile),
      method: httpMethods.put,
    });

    return response?.data;
  }

  async updateMyEmail(updateEmail: ChangeEmailRequest): Promise<boolean> {
    const response = await commonFetch<{ verify: boolean; }>(`${this.profileUrl}/email`, {
      body: JSON.stringify(updateEmail),
      method: httpMethods.put,
    });

    return response?.data?.verify;
  }

  async updateMyPassword(updatePassword: ExistingPasswordValidatedCredential): Promise<void> {
    await commonFetch(`${this.profileUrl}/password`, {
      body: JSON.stringify(updatePassword),
      method: httpMethods.put,
    });
  }
}

export const profileApiService = new ProfileApiService();
